import VideoRoom from './videoRoom';

export default VideoRoom;
